import { useState } from "react";
import ResultsTable from "./components/ResultsTable";

let url =
  "https://australia-southeast1-ttcf-304404.cloudfunctions.net/getApplications";

function App() {
  const [loading, setLoading] = useState(false);
  const [applicationName, setApplicationName] = useState("");
  const [applicationNumber, setApplicationNumber] = useState("");
  const [data, setData] = useState([]);

  const fetchData = async (applicationName, applicationNumber) => {
    setLoading(true);
    const requestUrl = new URL(url);
    const params = {
      app_name: applicationName || "",
      app_no: applicationNumber || "",
    };
    Object.keys(params).forEach((key) =>
      requestUrl.searchParams.append(key, params[key])
    );
    fetch(requestUrl, {
      method: "GET",
      mode: "cors",
    })
      .then((response) => response.json())
      .then((data) => {
        let filteredData = data.filter(
          (x) => x.decision === "No Decision Made"
        );
        setData(filteredData);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="search-container">
        <input
          className="app-input"
          placeholder="Application Name"
          name="applicationName"
          onChange={(e) => setApplicationName(e.target.value)}
          value={applicationName}
        />
        <input
          className="number-input"
          placeholder="Application Number"
          name="applicationNumber"
          onChange={(e) => setApplicationNumber(e.target.value)}
          value={applicationNumber}
        />
        <button
          className="submit-button"
          disabled={loading}
          onClick={() => fetchData(applicationName, applicationNumber)}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>
      <ResultsTable
        data={data}
        message={
          !applicationName && !applicationNumber
            ? "Enter your Application Name or Application Number"
            : "No results found"
        }
      />
    </>
  );
}

export default App;
